import { useEffect } from "react";
import Cookies from "js-cookie";
import HomePage from "./pages/HomePage";
import "./App.css";

const App = () => {
  useEffect(() => {
    const competiscaner = Cookies.get("competiscaner");
    if (!competiscaner?.trim()) {
      // Cookies.set("lastURL", window.location.href);
      window.location.href = "https://www.competiscan.com/login.php";
    }
  }, []);

  return <HomePage />;
};

export default App;
